/**
 * Markdown.tsx — safe Markdown renderer (react-markdown + GFM) for the KB
 * reading view (`page`) and chat answers (`chat`). Typography lives in
 * index.css (`.md` / `.md-chat`). No raw HTML is rendered (react-markdown
 * escapes by default), so untrusted page/answer text is safe to display.
 */
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({
  children,
  variant = "page",
}: {
  children: string;
  variant?: "page" | "chat";
}): JSX.Element {
  return (
    <div className={variant === "chat" ? "md md-chat" : "md"}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
